import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ConfigConstants, CseMaterialListModel, CseMaterialModel } from '@evorait/pace-core';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'pace-cse-material-list',
    templateUrl: './cse-material-list.component.html',
    styleUrls: ['./cse-material-list.component.scss'],
    standalone: false,
})
export class CseMaterialListComponent implements OnInit {
    @Input()
    public model: CseMaterialListModel;

    @Input()
    public parentForm: FormArray;

    @Input()
    public process: ConfigConstants.PROCESS_INDICATOR;

    public formChildren: FormArray;
    public cseMaterialListForm: FormGroup;
    public readonly faTrashAlt = faTrashAlt;
    public constructor(
        private readonly formBuilder: FormBuilder,
        @Inject(LogInstanceToken) private readonly log: LogInterface,
    ) {}
    public ngOnInit(): void {
        this.formChildren = this.formBuilder.array([]);
        this.cseMaterialListForm = this.formBuilder.group({
            formChildren: this.formChildren,
        });

        Promise.resolve(undefined)
            .then(() => {
                this.parentForm.push(this.cseMaterialListForm);
            })
            .catch((error: Error) =>
                this.log.error('Error in CseMaterialListComponent -> ngOnInit -> parentForm.push: ', error),
            );
    }

    /**
     * "Remove" a material  by deleting the value of the model
     *
     * @param {number} index - index of the material to be removed
     */
    public deleteMaterial(index: number): void {
        this.model.removeModel(index);
    }

    /**
     * "Add" a material by adding new model
     */
    public addMaterial(): void {
        this.model.addModel(new CseMaterialModel('', undefined, '', this.process, false, true, false));
    }
}
